import React from "react";
import { Link } from "react-router-dom";
import myImg from "../../Assets/jen.jpg";
import Particle from "../Particle";
import SpecializedServices from "./SpecializedServices";
import Type from "./Type";
import Tilt from "react-parallax-tilt";

function Home() {
  return (
    <section className="bg-accent-black text-white selection:text-white selection:bg-black min-h-screen">
      <div className="relative min-h-[90vh] flex items-center pt-24 pb-12" id="home">
        <Particle />
        <div className="container mx-auto px-6 z-10">
          <div className="flex flex-col lg:flex-row items-start lg:gap-16 gap-12">
            <div className="lg:w-3/5 text-left">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-black mb-6 leading-[1.1] tracking-tight text-white uppercase">
                I craft high-performance video ads &<br className="hidden md:block" />
                <span className="text-brand">visual assets that power your funnels.</span>
              </h1>
              <p className="text-base md:text-lg text-zinc-400 mb-10 max-w-xl border-l-2 border-zinc-800 pl-6 py-1 leading-relaxed">
                Specializing in scroll-stopping VSLs and conversion-focused imagery that.<span className="text-brand font-medium"> turn viewers into customers.</span>
              </p>

              <div className="flex flex-wrap gap-4 mb-16">
                <Link to="/project">
                  <button className="px-7 py-4 bg-brand text-white font-bold rounded-lg hover:bg-brand-dark transition-all duration-300 transform active:scale-95 shadow-xl shadow-brand/20">
                    View My Winning Edits & Collaboration
                  </button>
                </Link>
                <a href="https://cris-portfolio-official.vercel.app/" target="_blank" rel="noopener noreferrer">
                  <button className="px-7 py-4 bg-transparent border border-zinc-800 text-white font-bold rounded-lg hover:bg-brand/10 hover:border-brand hover:text-brand transition-all duration-300 transform active:scale-95">
                    My Developer Portfolio
                  </button>
                </a>
              </div>
            </div>

            <div className="lg:w-2/5 relative flex flex-col items-center lg:items-end w-full lg:pt-2">
              <Tilt className="w-full max-w-[420px] cursor-pointer" perspective={500} scale={1.02} transitionSpeed={2500}>
                <div className="relative">
                  <div className="absolute inset-x-0 top-0 h-full w-full bg-white/5 blur-[100px] rounded-full"></div>
                  <img
                    src={myImg}
                    alt="home pic"
                    className="relative z-10 w-full h-[280px] lg:h-[340px] object-cover object-top rounded-2xl grayscale transition-all duration-500 hover:grayscale-0 border border-white/10 active:scale-95"
                  />
                </div>
              </Tilt>
              <div className="mt-6 text-lg md:text-xl font-bold text-white tracking-widest text-center lg:text-right w-full max-w-[420px] min-h-[40px] uppercase">
                <Type />
              </div>
            </div>
          </div>
        </div>
      </div>
      <SpecializedServices />
    </section>
  );
}

export default Home;
